import { Component, OnInit, Input } from '@angular/core';
import {NgClassType} from "../../model/common.model";
import {NgClass} from "@angular/common";

@Component({
  selector: 'actions-container',
  templateUrl: './actions-container.component.html',
  imports: [
    NgClass
  ],
  standalone: true
})
export class ActionsContainerComponent implements OnInit {

  @Input() ngClass: NgClassType

  constructor() { }

  ngOnInit(): void {
  }

}
